import React, { useState } from 'react';

function SurveyStepFive({ formData, onNext }) {
    const [reportConfidence, setReportConfidence] = useState(formData.reportConfidence || '');
    const [reportComments, setReportComments] = useState(formData.reportComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!reportConfidence) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ reportConfidence, reportComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 1: Compliance & Training</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                How confident are you in knowing how to report a dispensing error or near-miss? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`report-rating-${option}`}
                            name="reportConfidence"
                            value={option}
                            checked={reportConfidence === option}
                            onChange={() => setReportConfidence(option)}
                        />
                        <label htmlFor={`report-rating-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={reportComments}
                    onChange={(e) => setReportComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!reportConfidence}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepFive;
